var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-circle",
    clipPath: "url(#clip0_385_1592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8232 13.625C24.8232 15.3655 24.1318 17.0347 22.9011 18.2654C21.6704 19.4961 20.0012 20.1875 18.2607 20.1875C16.5203 20.1875 14.8511 19.4961 13.6204 18.2654C12.3896 17.0347 11.6982 15.3655 11.6982 13.625C11.6982 11.8845 12.3896 10.2153 13.6204 8.98461C14.8511 7.7539 16.5203 7.0625 18.2607 7.0625C20.0012 7.0625 21.6704 7.7539 22.9011 8.98461C24.1318 10.2153 24.8232 11.8845 24.8232 13.625Z",
    fill: "#44F2A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.760742 18C0.760742 13.3587 2.60449 8.90752 5.88637 5.62563C9.16826 2.34374 13.6195 0.5 18.2607 0.5C22.902 0.5 27.3532 2.34374 30.6351 5.62563C33.917 8.90752 35.7607 13.3587 35.7607 18C35.7607 22.6413 33.917 27.0925 30.6351 30.3744C27.3532 33.6563 22.902 35.5 18.2607 35.5C13.6195 35.5 9.16826 33.6563 5.88637 30.3744C2.60449 27.0925 0.760742 22.6413 0.760742 18ZM18.2607 2.6875C15.3771 2.68765 12.5522 3.50204 10.111 5.03694C7.66983 6.57183 5.71167 8.76484 4.46191 11.3635C3.21215 13.9623 2.72159 16.8611 3.04668 19.7263C3.37176 22.5915 4.4993 25.3067 6.29949 27.5594C7.85262 25.0569 11.2717 22.375 18.2607 22.375C25.2498 22.375 28.6667 25.0547 30.222 27.5594C32.0222 25.3067 33.1497 22.5915 33.4748 19.7263C33.7999 16.8611 33.3093 13.9623 32.0596 11.3635C30.8098 8.76484 28.8517 6.57183 26.4105 5.03694C23.9693 3.50204 21.1444 2.68765 18.2607 2.6875Z",
    fill: "#44F2A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_1592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.760742 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.cbb6ed28b48afdd590a52623e114f9c3.svg";
export { ForwardRef as ReactComponent };